import React from 'react'
import {Tabs, Tab} from 'material-ui/Tabs'



export default React.createClass({
  displayName: 'Tabs',
  contextTypes: {
    router: React.PropTypes.object.isRequired
  },
  getInitialState() {
    let {pathname} = this.props.location
    let {tabList} = this.props

    let selectedIndex = 0
    for (var i = 0; i < tabList.length; i++) {
      if(pathname === tabList[i].route) {
        selectedIndex = i
        break
      }
    }
    return {
      progress:0,
      selectedIndex:selectedIndex,
    }
  },

  _onActive(tab){
    this.context.router.push(tab.props.route)
  },

  renderPage(tab){
    if(tab.route === this.props.location.pathname) {
      return this.props.children
    }
  },
  renderTab(tab){
    return (
        <Tab
          key={tab.route}
          label={tab.label}
          route={tab.route}
          onActive={this._onActive}>
           {this.renderPage(tab)}
        </Tab>
      )
  },
  render() {
    let {tabList} = this.props
    return (
      <Tabs initialSelectedIndex={this.state.selectedIndex}>
        {tabList.map(this.renderTab)}
      </Tabs>
    )
  }
})



/** WEBPACK FOOTER **
 ** ./src/app/components/Tabs.js
 **/